module.exports = __webpack_public_path__ + "img/loginPage_bg.a4b58323.png";